module.exports = __webpack_public_path__ + "img/1369795576.3fb2855b.jpg";